/* RESPONSIBLE TEAM: team-conversations */
import GlobalLoadingRoute from 'embercom/routes/base/global-loading-route';

let UsersLoadingRoute = GlobalLoadingRoute.extend({});

export default UsersLoadingRoute;
